import App from '../app';

App();



// WEBPACK FOOTER //
// ./app/javascript/packs/react_frontend.js